import React, { useReducer, useContext } from "react";
import axios from "axios";
import StoreContext from "./StoreContext";
import StoreReducer from "./StoreReducer";
import {
  SET_DISPLAY_CONTENT,
  GET_ACTIVE_STORES,
  GET_STORES,
  FILTER_STORES,
  CLEAR_FILTERED_STORES,
  SEARCH_STORES,
  SELECTED_STORE,
  FORM_DATA,
  FORM_ERROR,
  STORE_ERROR,
} from "../types";
import qs from "query-string";

// Contexts
import AuthContext from "../auth/AuthContext";
import LayoutContext from "../layout/LayoutContext";

const StoreState = (props) => {
  const default_form_data = {
    status: true,
    cod: false,
    base_url: "",
    api_key: "",
    api_secret: "",
    store_name: "",
    shared_secret: "",
    // pixel_id: "",
  };
  const default_form_error = {
    base_url: "",
    shared_secret: "",
    // pixel_id: "",
  };

  const initialState = {
    display_content: "",
    activeStores: null,
    stores: null,
    stores_filtered: null,
    stores_searched: [],
    selected_store: null,
    form_data: default_form_data,
    form_error: default_form_error,
    store_error: null,
  };

  const [state, dispatch] = useReducer(StoreReducer, initialState);
  const { user } = useContext(AuthContext);
  const { setLoading, setAlert } = useContext(LayoutContext);

  const setDisplayContent = (page) => {
    dispatch({
      type: SET_DISPLAY_CONTENT,
      payload: page,
    });
  };

  const getActiveStores = async () => {
    try {
      const res = await axios.get("/api/stores/active");

      dispatch({
        type: GET_ACTIVE_STORES,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: STORE_ERROR,
        payload: err.response.msg,
      });
    }
  };

  const getStores = async () => {
    try {
      const res = await axios.get("/api/stores");

      dispatch({
        type: GET_STORES,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: STORE_ERROR,
        payload: err.response.msg,
      });
    }
  };

  const filterStores = (text) => {
    dispatch({
      type: FILTER_STORES,
      payload: text,
    });
  };

  const clearFilteredStores = () => {
    dispatch({
      type: CLEAR_FILTERED_STORES,
    });
  };

  const searchStores = async (searchText) => {
    try {
      const params = {
        searchText,
      };
      const params_encoded = qs.stringify(params, {
        arrayFormat: "comma",
      });

      const res = await axios.get(`/api/stores/search?${params_encoded}`);
      dispatch({
        type: SEARCH_STORES,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: SEARCH_STORES,
        payload: [],
      });
    }
  };

  const clearSearchStores = () => {
    dispatch({
      type: SEARCH_STORES,
      payload: [],
    });
  };

  const getStore = async (store_name) => {
    if (
      store_name &&
      (!state.selected_store || state.selected_store.store_name !== store_name)
    ) {
      setLoading(true);

      try {
        const res = await axios.get(`/api/stores/${store_name}`);

        dispatch({
          type: SELECTED_STORE,
          payload: res.data,
        });
      } catch (err) {
        // Not Found - Return To Home
        window.location.replace(`${window.location.origin}/store`);
        dispatch({
          type: STORE_ERROR,
          payload: err.response.msg,
        });
      }

      setLoading(false);
    }
  };

  const clearSelectedStore = () => {
    dispatch({
      type: SELECTED_STORE,
      payload: null,
    });
  };

  const setFormData = (data) => {
    dispatch({
      type: FORM_DATA,
      payload: data,
    });
  };

  const setFormError = (error) => {
    dispatch({
      type: FORM_ERROR,
      payload: error,
    });
  };

  const createStore = async () => {
    setLoading(true);

    try {
      const res = await axios.post("/api/stores", {
        data: state.form_data,
        username: user.name,
      });

      setAlert("Store Created.", "success");
      dispatch({
        type: SELECTED_STORE,
        payload: res.data,
      });
    } catch (err) {
      setAlert(err.response.data.msg, "error");
    }

    setLoading(false);
  };

  const updateStore = async (changes) => {
    setLoading(true);

    if (!changes) {
      setAlert("No Changes Has Been Made.", "info");
    } else {
      try {
        const res = await axios.put(
          `/api/stores/${state.selected_store.store_name}`,
          {
            data: state.form_data,
            username: user.name,
          }
        );

        setAlert("Store Saved.", "success");
        dispatch({
          type: SELECTED_STORE,
          payload: res.data,
        });
      } catch (err) {
        setAlert(err.response.data.msg, "error");
      }
    }

    setLoading(false);
  };

  return (
    <StoreContext.Provider
      value={{
        default_form_data,
        default_form_error,

        display_content: state.display_content,
        activeStores: state.activeStores,
        stores: state.stores,
        stores_filtered: state.stores_filtered,
        stores_searched: state.stores_searched,
        selected_store: state.selected_store,
        form_data: state.form_data,
        form_error: state.form_error,
        store_error: state.store_error,

        setDisplayContent,
        getActiveStores,
        getStores,
        filterStores,
        clearFilteredStores,
        searchStores,
        clearSearchStores,
        getStore,
        clearSelectedStore,
        setFormData,
        setFormError,
        createStore,
        updateStore,
      }}
    >
      {props.children}{" "}
    </StoreContext.Provider>
  );
};

export default StoreState;
